(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shim-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initUgcSection(section) {
    var track = section.querySelector('.shim-ugc__track');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.shim-ugc__card'));
    var playPauseBtn = section.querySelector('.shim-ugc__playpause');
    var intervalMs = parseInt(section.dataset.autoplayMs, 10) || 7000;
    var timer = null;
    var isPlaying = true;
    var activeCard = null;

    // lazy load of videos
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var video = entry.target.querySelector('video.shim-ugc__video');
            if (video && !video.dataset.loaded) {
              video.preload = 'metadata';
              video.dataset.loaded = 'true';
            }
          }
        });
      }, { root: track, threshold: 0.25 });
      cards.forEach(function (card) { io.observe(card); });
    }

    // autoplay of carousel
    function scrollToNext() {
      if (activeCard) return; // preventing from sliding when a video is playing
      if (!cards.length) return;
      var cardWidth = cards[0].getBoundingClientRect().width + 16;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      track.scrollTo({
        left: atEnd ? 0 : track.scrollLeft + cardWidth,
        behavior: 'smooth'
      });
    }

    function setIcons(playing) {
      var pauseIcon = section.querySelector('.shim-ugc__icon-pause');
      var playIcon = section.querySelector('.shim-ugc__icon-play');
      if (pauseIcon) pauseIcon.hidden = !playing;
      if (playIcon) playIcon.hidden = playing;
      if (playPauseBtn) playPauseBtn.dataset.state = playing ? 'playing' : 'paused';
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(scrollToNext, intervalMs);
      isPlaying = true;
      setIcons(true);
    }

    function pauseAutoplay() {
      stopAutoplay();
      isPlaying = false;
      setIcons(false);
    }

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', function () { if (isPlaying) startAutoplay(); });
    track.addEventListener('touchstart', stopAutoplay, { passive: true });

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', function () {
        if (isPlaying) { pauseAutoplay(); } else { startAutoplay(); }
      });
    }

    startAutoplay();

    // keep the video playing on scroll
    function stopActive() {
      if (!activeCard) return;
      var v = activeCard.querySelector('video.shim-ugc__video');
      var p = activeCard.querySelector('.shim-ugc__player');
      if (v) { v.pause(); v.muted = true; v.controls = false; v.load(); }
      p.classList.remove('is-floating');
      activeCard.querySelector('.shim-ugc__play-icon').style.display = '';
      activeCard = null;
    }

    // checks if the card still plays on its section
    var mediaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target.closest('.shim-ugc__card');
        if (card !== activeCard) return;
        card.querySelector('.shim-ugc__player')
          .classList.toggle('is-floating', !entry.isIntersecting);
      });
    }, { threshold: 0.3 });

    cards.forEach(function (card) {
      var media = card.querySelector('.shim-ugc__media');
      var playIcon = card.querySelector('.shim-ugc__play-icon');
      var video = card.querySelector('video.shim-ugc__video');
      var closeBtn = card.querySelector('.shim-ugc__mini-close');
      if (!media || !playIcon || !video) return;

      mediaObserver.observe(media);

      playIcon.addEventListener('click', function () {
        stopActive();
        activeCard = card;
        video.muted = false;
        video.controls = true;
        playIcon.style.display = 'none';
        var p = video.play();
        if (p) p.catch(function (err) { console.error('Video play failed:', err); });
      });

      video.addEventListener('ended', stopActive);
      if (closeBtn) closeBtn.addEventListener('click', stopActive);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') stopActive();
    });
  }

  document.querySelectorAll('.shim-ugc').forEach(initUgcSection);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.shim-ugc');
    if (section) initUgcSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
